/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import "./styles.css";

/* Library imports */
import React, {Component} from "react";
import {Switch, Link, Route} from "react-router-dom";
import PropTypes from "prop-types";

/* Component imports */
import ModalLg from "./components/core/ModalLg/ModalLg";
import LoginProfessionals from "./components/ProfessionalLogin/ProfessionalLogin";
import RecruiterLoginMain from "./components/RecruiterLogin/RecruiterLoginMain";
import LoadingBar from "./components/core/LoadingBarLg/LoadingBarLg";
import OverlayTrans from "./components/core/OverlayTrans/OverlayTrans";
import ConstantsLg from "./ConstantsLg";
import MobileLogin from "./components/MobileLogin/MobileLogin";
import ProfessionalLoginEmailDesktop from "./components/ProfessionalLoginEmailDesktop/ProfessionalLoginEmailDesktop";
import ProfessionalLoginEmailMobile from "./components/ProfessionalLoginEmailMobile/ProfessionalLoginEmailMobile";
import FreelancerLogin from './components/freelancerLogin/FreelancerLogin';

/*** End Imports ***/

class LoginModal extends Component {
    constructor (props) {
        super(props);

        this.state = {
            pageIdentifier: null,
            showOverlay: false,
            showLoginPopup: true
        };
    };

    componentWillMount () {
        const {loginType} = this.props;
        let pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.LANDING_PAGE;

        switch (loginType) {
            case ConstantsLg.LOGIN_TYPE.RECRUITER:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.RECRUITER_LOGIN_FLOW;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_MOBILE:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_DESKTOP:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_DESKTOP;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_MOBILE:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_MOBILE;
                break;
            case ConstantsLg.LOGIN_TYPE.FREELANCER:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.FREELANCER_LOGIN_FLOW;
                break;
        }

        this.setState({
            pageIdentifier: pageId,
            showLoginPopup: true
        });
    }

    componentWillReceiveProps(props, state){
        const {loginType} = props;
        let pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW;

        switch (loginType) {
            case ConstantsLg.LOGIN_TYPE.RECRUITER:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.RECRUITER_LOGIN_FLOW;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_MOBILE:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_DESKTOP:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_DESKTOP;
                break;
            case ConstantsLg.LOGIN_TYPE.PROFESSIONAL_EMAIL_MOBILE:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_MOBILE;
                break;
            case ConstantsLg.LOGIN_TYPE.FREELANCER:
                pageId = ConstantsLg.LOGIN_PAGE_IDENTIFIER.FREELANCER_LOGIN_FLOW;
                break;
        }

        this.setState({
            pageIdentifier: pageId,
            showLoginPopup: true
        });
    }

    onClose = () => {
        this.props.onClose();
        this.setState({
            showLoginPopup: false
        });
    };

    showLoginModalLanding = () => {
        this.setState ({
            pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.LANDING_PAGE
        });
    };

    onProfLoginSuccess = () => {
        this.props.onProfLoginSuccess();
    };

    onRecLoginSuccess = () => {
        this.props.onRecLoginSuccess();
    };

    onFreelancerLoginSuccess = () => {
        this.props.onFreelancerLoginSuccess();
    };

    onProfLgClick = () => {
        window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional Clicked");
        this.setState({
            pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW
        });
    };

    onRecLgClick = () => {
        window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter Clicked");
        this.setState({
            pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.RECRUITER_LOGIN_FLOW
        });
    };

    toShowOverlay = bool => {
        this.setState({showOverlay: bool});
    };

    onClickCrossIconForProfessional = () => {
      this.props.onClickCrossIconForProfessional();
    };

    onCloseMobileModal = () => {
        this.props.onCloseMobileModal();
    };

    onClickCrossIconForFreelancer = () => {
        this.props.onClickCrossIconForFreelancer();
    };

    onClickCrossIconForRecruiter = () => {
        this.props.onClickCrossIconForRecruiter();
    };

    onClickChangeUserLoginModal = (loginType) => {
        this.props.onClickChangeUserLoginModal(loginType);
    };

    _onLoginSuccess = () => {

    };

    changePosition = () => {
        this.setState({position: ''});
    };

    getViewToBeRendered = pageIdentifier => {
        let view = null;
        switch (pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.LOADING:
                view = <div>Login In progress...</div>;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW:
                view = <LoginProfessionals
                    onLoginSuccess = {this.onProfLoginSuccess}
                    onClose = {this.onClose}
                    toShowOverlay = {this.toShowOverlay}
                    showLoginModalLanding = {this.showLoginModalLanding}
                    onClickCrossIconForProfessional = {this.onClickCrossIconForProfessional}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    onLoginSuccessProfessional = {this.props.onLoginSuccessProfessional}
                    showAppLodingView = {this.props.showAppLodingView}
                />;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE:
                view = <MobileLogin
                    ref={(instance) => {this.modLogin = instance } }
                    loginCallback = {this._onLoginSuccess}
                    hist = {this.props.history}
                    positionChng = {this.changePosition}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    onCloseMobileModal = {this.onCloseMobileModal}
                    toRedirectPageIdentifier = {this.props.toRedirectPageIdentifier}
                    onLoginSuccessProfessionalMobile = {this.props.onLoginSuccessProfessionalMobile}
                    showAppLodingView = {this.props.showAppLodingView}
                />;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.RECRUITER_LOGIN_FLOW:
                view = <RecruiterLoginMain
                    onLoginSuccess = {this.onRecLoginSuccess}
                    onClose = {this.onClose}
                    showLoginModalLanding = {this.showLoginModalLanding}
                    toShowOverlay = {this.toShowOverlay}
                    onClickCrossIconForRecruiter = {this.onClickCrossIconForRecruiter}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    onLoginSuccessRecruiter = {this.props.onLoginSuccessRecruiter}
                    showAppLodingView = {this.props.showAppLodingView}
                />;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_DESKTOP:
                view = <ProfessionalLoginEmailDesktop
                    onLoginSuccess = {this.onRecLoginSuccess}
                    onClose = {this.onClose}
                    showLoginModalLanding = {this.showLoginModalLanding}
                    toShowOverlay = {this.toShowOverlay}
                    onClickCrossIconForProfessional = {this.onClickCrossIconForProfessional}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    onLoginSuccessProfessional = {this.props.onLoginSuccessProfessional}
                    showAppLodingView = {this.props.showAppLodingView}
                />;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_MOBILE:
                view = <ProfessionalLoginEmailMobile
                    onLoginSuccess = {this.onRecLoginSuccess}
                    onClose = {this.onClose}
                    showLoginModalLanding = {this.showLoginModalLanding}
                    toShowOverlay = {this.toShowOverlay}
                    onClickCrossIconForProfessional = {this.onClickCrossIconForProfessional}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    onLoginSuccessProfessional = {this.props.onLoginSuccessProfessionalMobile}
                    showAppLodingView = {this.props.showAppLodingView}
                />;
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.FREELANCER_LOGIN_FLOW:
                view = <FreelancerLogin
                    onLoginSuccess = {this.onFreelancerLoginSuccess}
                    onClose = {this.onClose}
                    showLoginModalLanding = {this.showLoginModalLanding}
                    toShowOverlay = {this.toShowOverlay}
                    onClickCrossIconForFreelancer = {this.onClickCrossIconForFreelancer}
                    onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    // onLoginSuccessProfessional = {this.props.onLoginSuccessProfessional}
                    onLoginSuccessFreelancer = {this.props.onLoginSuccessFreelancer}
                    showAppLodingView = {this.props.showAppLodingView}
                    notification = {this.props.showNotification}
                />;
                break;
            default:
                view = <div>This is error page</div>;
                break;
        }

        return view;
    };

    render () {

        const { 
            showOverlay, 
            pageIdentifier, 
            showLoginPopup 
        } = this.state;

        let mobileModalClassName = null;

        if(pageIdentifier == ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE || pageIdentifier == ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_MOBILE) {
            mobileModalClassName = "for-mobile-only"
        }

        return (
            <ModalLg
                widthPx = {500}
                heightPx = {450}
                isOpen = {showLoginPopup}
                childrenClassName = {mobileModalClassName}
            >

                {
                    showOverlay ? 
                    <LoadingBar type={1}/>
                    : 
                    ''
                }

                {
                    this.getViewToBeRendered(pageIdentifier)
                }

                {
                    showOverlay ? 
                    <OverlayTrans/>
                    : 
                    ''
                }

            </ModalLg>
        );
    }
}

LoginModal.PropTypes = {
    loginType: PropTypes.number,
    onProfLoginSuccess: PropTypes.func.isRequired,
    onRecLoginSuccess: PropTypes.func.isRequired
};

export default LoginModal;



// WEBPACK FOOTER //
// ./src/LoginModal.js